export default __webpack_public_path__ + "static/media/github.4518a790.svg";